import { SharedUtils } from 'primevue/themes';

export default (...presets) => SharedUtils.object.mergeKeys(...presets);
